<template lang="pug">
  v-card.mx-auto(elevation='24', max-width='100%')
  
    v-row(justify='center')
      v-dialog(v-model='dialog', fullscreen='', hide-overlay='', transition='dialog-bottom-transition')
        v-card
          v-toolbar(dark='', color='#043343')
            v-toolbar(dark='', color='#043343')
              v-btn(icon='', dark='', @click='dialog = false; cancel()')
                v-icon mdi-close
              //- v-spacer
              //- v-toolbar-title {{categorySelected}}
              v-spacer
              div {{maps[current].date | date-format-string}}
              v-spacer
              v-switch(dark='', v-model='cycle', label='Automático', inset='', style="martin-top: 10px;")
          v-container(fluid='')
              v-row.fill-height(align='center', justify='center')
                v-sheet(color='blue', tile='', max-width="100%", max-height="150")
                  v-zoomer(style='width: 100%; height: 100%; border: solid 1px silver;')
                    v-img.grey.darken-4.img-slider(:src='maps[current].url', contain="", max-width="100%")
                      template(v-slot:placeholder='')
                        v-row.fill-height.ma-0(align='center', justify='center')
                          v-progress-circular(indeterminate='', color='grey lighten-5')
                  .v-window__prev
                    button.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--dark.v-size--default(type='button', aria-label='Previous visual', @click="prevMap")
                      span.v-btn__content
                        i.v-icon.notranslate.mdi.mdi-arrow-left-bold-circle.theme--dark(aria-hidden='true', style='font-size: 36px;')
                  .v-window__next
                    button.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--dark.v-size--default(type='button', aria-label='Next visual', @click="nextMap")
                      span.v-btn__content
                        i.v-icon.notranslate.mdi.mdi-arrow-right-bold-circle.theme--dark(aria-hidden='true', style='font-size: 36px;')
                      span.v-ripple__container
                        span.v-ripple__animation.v-ripple__animation--visible.v-ripple__animation--in(data-activated='635993.0850000018', style='width: 43.6485px; height: 43.6485px; transform: translate(-3.82426px, -3.82426px) scale3d(1, 1, 1); opacity: 0.25;')
                  .slider-items-control
                    button.v-carousel__controls__item.v-btn.v-btn--flat.v-btn--icon.v-btn--round.theme--dark.v-size--small(v-for='(obj, i) in maps', 
                      :key='i', type='button', value='1',
                      :class="{'v-item--active v-btn--active': current == i}"
                      @click="current = i")
                      span.v-btn__content
                        i.v-icon.notranslate.mdi.mdi-checkbox-blank-circle.theme--dark(aria-hidden='true', style='font-size: 18px;')
</template>

<script>
export default {
  props: {
    interval: {
      type: Number,
      required: false,
      default: 2500
    },
    maps: {
      type: Array
    },
    categorySelected: {
      type: String
    }
    // loopFunction: null
  },
  watch: {
    cycle: function(val) {
      if (val) {
        if (!this.loopFunction) {
          this.loopFunction = setInterval(this.loopUpdate, this.interval)
        }
      } else {
        clearInterval(this.loopFunction)
        this.loopFunction = null
      }
    },
    dialog: function(val) {
      if (!val) {
        this.$emit('cancel')
      }
    }
  },
  data() {
    return {
      dialog: true,
      cycle: false,
      current: 0
    }
  },
  methods: {
    cancel() {
      this.$emit('cancel')
    },
    nextMap() {
      if (this.current + 1 < this.maps.length) {
        this.current += 1
      } else {
        this.current = 0
      }
    },
    prevMap() {
      if (this.current - 1 >= 0) {
        this.current -= 1
      } else {
        this.current = this.maps.length - 1
      }
    },
    loopUpdate() {
      // console.log('loopUpdate')
      if (this.cycle) {
        this.nextMap()
      }
    }
  },
  mounted() {
    // this.loopFunction = setInterval(this.loopUpdate,this.interval)
  }
}
</script>

<style scoped>
.img-slider {
  height: calc(100vh - 120px) !important;
  /* height:100vh; */
}
.slider-items-control {
  align-items: center;
  background: rgba(0, 0, 0, 0.3);
  bottom: 0;
  display: flex;
  height: 50px;
  justify-content: center;
  list-style-type: none;
  position: absolute;
  width: 98%;
  z-index: 1;
  max-width: 98% !important;
  margin-left: 1%;
  overflow-x: auto;
}

.slider-items-control button {
  /* width: 10px; */
  margin-left: 0;
  margin-right: 0;
}
</style>
